export default __webpack_public_path__ + "7b6697abed85d1d01981eaf510c46fdf.svg";